<template>
  <v-list class="nav-list pa-3">
    <div>
      <v-list-item 
        class="white--text" 
        data-cy="devicesView"
        :to="routeConstants.DASHBOARD_URL" 
        ripple="ripple">
        <v-list-item-icon class="layout-drawer__icon">
          <v-icon>dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('routes.devices') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item 
        class="white--text" 
        :to="routeConstants.MOVES_URL" 
        ripple="ripple"
        data-cy="movesView">
        <v-list-item-icon class="layout-drawer__icon">
          <v-icon>directions_walk</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('routes.moves') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        class="white--text"
        :to="routeConstants.SETTINGS_URL"
        ripple="ripple"
        data-cy="settingsView">
        <v-list-item-icon class="layout-drawer__icon">
          <v-icon>settings</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('routes.settings') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import * as routeConstants from '@/router/constants';

export default {
  name: 'LayoutDrawerList',
  data: () => ({
    routeConstants: routeConstants
  })
};
</script>
